<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editDevice" ref="editDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="editDevice.jigouid" :propsjigouname="editDevice.jigouname" @change="changeRsljigou"></Rsljigou>
            <el-button type="danger" plain @click="editDeviceUnbind">一键解绑所有用户</el-button>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      editDevice: {
        jigouid: '0',
        jigouname: ''
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.editDevice.jigouid = this.parentdata.params.Jigouid
      this.editDevice.jigouname = this.parentdata.params.Jigouname
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditDeviceJigou()
    },
    changeRsljigou (vid, vname) {
      this.editDevice.jigouid = vid
      this.editDevice.jigouname = vname
    },
    editDeviceUnbind () {
      this.apiEditDeviceUnbind()
    },
    apiEditDeviceJigou: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassid: that.parentdata.params.glassid,
        jigouid: that.editDevice.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDeviceJigou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditDeviceUnbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassid: that.parentdata.params.glassid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDeviceUnbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
